<script lang="ts" setup>
import { useDialog, currentDialogs } from "@/application/composables/dialog";
import { useWindowSize } from "@vueuse/core";
import { computed } from "vue";
import { useDisplay } from "vuetify";

const { closeDialog } = useDialog();
const { height } = useWindowSize();
const { xs: isFullScreen, smAndDown } = useDisplay();

const maxHeight = computed(() =>
  isFullScreen.value ? height.value : (height.value / 100) * 90,
);

const onCloseDialog = (key: string, value: boolean) => {
  if (value) return;
  closeDialog(key);
};
</script>

<template>
  <VDialog
    v-for="(dialog, key) in currentDialogs"
    :key
    :fullscreen="isFullScreen"
    :model-value="!dialog.config.closing"
    transition="slide"
    max-width="100%"
    @update:model-value="(value) => onCloseDialog(key, value)"
  >
    <VCard
      :width="dialog.config.width"
      :max-height="maxHeight"
      :rounded="isFullScreen ? '0' : 'lg'"
      :class="{ 'h-100': isFullScreen }"
      class="main-dialog mx-auto overflow-y-auto"
      max-width="100%"
    >
      <VCardTitle v-if="dialog.config.title" class="pb-0">
        <h4 class="text-heading text-accent text-truncate">
          {{ dialog.config.title }}
        </h4>
        <p v-if="dialog.config.subtitle" class="text-body-2 text-emphasis mt-1">
          {{ dialog.config.subtitle }}
        </p>

        <VBtn
          :size="32"
          class="position-absolute right-0 top-0 mt-3 mr-3"
          icon="$close"
          variant="plain"
          @click="onCloseDialog(key, false)"
        >
          <VIcon size="24" />
        </VBtn>
      </VCardTitle>

      <VCardText
        :style="`--content-max-height: ${maxHeight - (smAndDown ? 72 : 58)}px`"
        class="main-dialog__content overflow-y-auto"
      >
        <component
          :is="dialog.component"
          v-bind="dialog.props"
          @cancel="onCloseDialog(key, false)"
          @close="onCloseDialog(key, false)"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.main-dialog {
  &__content {
    max-height: calc(var(--content-max-height));
  }
}
</style>
